import { SvgConsentTwo, SvgConsentTwoATwoEnd, SvgConsentOneATwoA, SvgConsentOneB, SvgConsentOneBEnd} from "components/Images/consent";

const consentTwo = [
      {
        id: 'consent-2-learnmore',
        type: 'learnmore',
        text: '<p>Both Alex and Sam seem keen to grab a drink and chat, however, it is good to remember that alcohol can make you feel more comfortable doing things you wouldn’t normally do. </p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgConsentTwo,
        learnmore: {
          title: "More about consent 🤔",
          content: "<p>Alcohol and drugs can impair a person’s ability to make decisions. Self-awareness, communication skills, the ability to read social cues, and think and act with reason go out the window. The more you have, the more it will affect you. Alcohol can make it much harder to give consent to sex or figure out whether you’ve been given consent. </p>"
        },
        nextStepId: 'consent-2a',
      },
      {
        id: 'consent-2a',
        type: 'question',
        text: "<p>After a few beers and a lot more dancing, Alex & Sam find themselves in their friend’s bedroom, with things getting very heated quite fast. </p><p>How does the night proceed?</p>",
        backgroundImage:  SvgConsentOneATwoA,
        options: [
          {
            id: 'consent-2a-option-1',
            text: 'They begin to enthusiastically pull each other’s clothes off after checking in with each other that they are ok to keep going.',
            icon: '😍',
            iconBackground: '#fededd',
            nextStepId: 'consent-2a-learnmore'
          },
          {
            id: 'consent-2a-option-2',
            text: 'Sam and Alex soon realise they may have a bit too much to drink. They stop, have a quick chat, and decide to call it a night and meet up another time.',
            icon: '😐',
            iconBackground:'#fbe9b6',
            nextStepId: 'consent-2b-end',
  
          }
        ]
      },
      {
        id: 'consent-2a-learnmore',
        type: 'learnmore',
        text: '<p>Alcohol can make it much harder to give consent to sex or figure out whether you’ve been given consent.</p><p>Even though Sam and Alex seem to have both consented to sexual activity, they have had a few beers which can make it much harder for them to give consent to sex or figure out whether they’ve been given consent. </p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgConsentOneATwoA,
        learnmore: {
          title: "More about consent 🤔",
          content: "<p>Drugs and alcohol can affect a person’s ability to make safe choices when it comes to sex, putting you at risk of <a href='https://bodytalk.org.au/keeping-an-eye-on-stis/' target='_blank' rel='noopener noreferrer'>sexually transmissible infections (STIs)</a>, unplanned pregnancy and sexual assault.</p>"
        },
        nextStepId: 'consent-2a-1-2',
      },
      {
        id: 'consent-2a-1-2',
        type: 'question',
        text: "<p>Alex and Sam continue to make out, as Alex starts to remove Sam’s clothes, they notice that Sam is nodding off and is not actively engaging.</p><p>How does the night proceed?</p>",
        backgroundImage:  SvgConsentOneB,
        options: [
          {
            id: 'consent-2a-option-1',
            text: 'Alex continues to pull Sam’s top off.',
            icon: '👕',
            iconBackground: '#c5d2ff',
            nextStepId: 'consent-2a-1-end'
          },
          {
            id: 'consent-2a-option-2',
            text: 'Alex realises that Sam has had too much to drink and is unable to consent. Alex pulls the blankets over Sam and goes out to touch base with their friends to make sure they can get Sam home safely.',
            icon: '😐',
            iconBackground:'#fbe9b6',
            nextStepId: 'consent-2a-2-end',
  
          }
        ]
      },
      {
        id: 'consent-2a-1-end',
        type: 'learnmore',
        text: '<p>Consent can’t be ‘freely given’ if any of the people involved are under the effect of alcohol or drugs as these substances can impact people’s capacity to give consent.</p><p>Alex needs to stop immediately. If they continue, this is sexual assault, and Alex can be charged with a crime. </p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgConsentOneB,
        learnmore: {
          title: "More about consent 🤔",
          content: "<p>A person is not able to consent if they are asleep. Alcohol makes consent harder to navigate, so if a potential partner has been drinking alcohol it’s up to you to recognise and respect if they’ve had too much to drink to give consent. </p><p>Non-consensual sexual activity (anything from touching and kissing to penetration) is against the law. The punishments for sexual assault are severe. Not only is it a crime, but the emotional consequences of rape and sexual assault can last a lifetime.</p>"
        },
        nextStepId: null,
      },
      {
        id: 'consent-2a-2-end',
        type: 'learnmore',
        text: "<p>In this situation, Alex made the right decision. A person is not able to consent if they are asleep. </p><p>Alcohol and drugs make consent harder to navigate, so if a partner has been drinking alcohol it’s up to you to recognise and respect if they’ve had too much to drink to give consent.</p>",
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgConsentTwoATwoEnd,
        learnmore: {
          title: "More about consent 🤔",
          content: "<p>If you see a friend who is out-of-it and is being intimate with someone then you should pull them aside and try your best to make sure that the person is safe and knows what they are doing. If it’s the opposite situation and your friend is the one who is with the out-of-it person then you should try to pull them aside and stop them from getting themselves into trouble.</p>"
        },
        nextStepId: null,
      },
      {
        id: 'consent-2b-end',
        type: 'learnmore',
        text: '<p>You always have the right to say ‘no’ and you always have the right to change your mind at any time. </p><p>Sam realises that they may have had too much to drink to make the best decisions around sexual activity and sexual health. Alex respects Sam and does not continue since consent has not been given.</p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgConsentOneBEnd,
        learnmore: {
          title: "More about consent 🤔",
          content: "<p>Drugs and alcohol can affect a person’s judgement and can make it really difficult to think clearly and make good decisions about all kinds of things including sex. Someone who is too drunk or high to know what’s going on cannot give consent. It’s OK to say “NO” to sex no matter what, especially if you feel uncomfortable or if you or your partner have had too much to drink.</p>"
        },
        nextStepId: null,
      }
]

export default consentTwo